import { Route } from "@angular/router";
import { FonctionComponent } from "./fonction.component";

export const FonctionRouting: Route = {
  path: "fonction",
  component: FonctionComponent,
  data: {
    breadcrumb: "Changement de fonction"
  }
};
